import React, { useState } from "react";
import { IntlProvider } from "react-intl";
import { getStoredLocale, storeLocale } from "~/helpers";
import enMessages from "../locales/en.json";
import frMessages from "../locales/fr.json";

const messagesMap: Record<string, Record<string, string>> = {
  en: enMessages,
  fr: frMessages,
};

export const LocalizationContext = React.createContext({
  locale: "en",
  setLocale: (_lang: string) => {},
});

const getAppLocale = (lang: string) => {
  const urlParams = new URLSearchParams(window.location.search);
  const urlLang = urlParams.get("lang");
  const storedLocale = getStoredLocale() || "";

  let appLocale = urlLang || lang || storedLocale;
  if (!appLocale) {
    const navigatorLocale = navigator.language;
    appLocale = navigatorLocale.split("-")[0];
  }

  return messagesMap[appLocale] ? appLocale : "en";
};

interface LocalizationWrapperProps {
  children: React.ReactNode;
  lang?: string;
}

export const LocalizationWrapper: React.FC<LocalizationWrapperProps> = ({
  lang = "",
  children,
}) => {
  const [appLocale, setAppLocale] = useState(getAppLocale(lang));

  const setLocale = (lang: string) => {
    const newLocale = messagesMap[lang] ? lang : "en";
    setAppLocale(newLocale);
    storeLocale(newLocale);

    const url = new URL(window.location.href);
    if (url.searchParams.has("lang")) {
      url.searchParams.set("lang", newLocale);
      window.history.replaceState({}, "", url.toString());
    }
  };

  return (
    <LocalizationContext.Provider value={{ locale: appLocale, setLocale }}>
      <IntlProvider
        messages={messagesMap[appLocale]}
        locale={appLocale}
        defaultLocale="en"
      >
        {children}
      </IntlProvider>
    </LocalizationContext.Provider>
  );
};
